import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.samplingModule;

export default class SamplingModule extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      trial_id: this.attr(null),
      sampling: this.attr({}),
      extra: this.attr({}),
    };
  }

  static methodConf = {
    http: {
      url: '/modules/sampling',
    },
    methods: {
      $get: {
        name: 'get',
        http: {
          url: '/:id/object',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/:id/object',
          method: 'put',
        },
      },
    },
  };
}
